module.exports = __webpack_public_path__ + "static/media/28-10.1d8fd41e.mp3";